import React, { useState } from 'react';
import {
  StudyListSidebar,
  StudyListSidebarSharedProps,
} from './StudyListSidebar';
import { HighlightsPanel } from 'pages/EligibilityCriteria/components/HighlightsModal/HighlightsPanel';

type Props = StudyListSidebarSharedProps & {
  disclosureId: string;
  defaultShowAbstracts: boolean;
  toggleAbstracts: () => void;
  toggleHighlights: () => void;
  enableHighlights: () => void;
};

export const HighlightsSidebar = ({
  disclosureId,
  defaultShowAbstracts,
  toggleAbstracts,
  toggleHighlights,
  enableHighlights,
  ...sidebarProps
}: Props) => {
  const [isShowingAbstracts, setIsShowingAbstracts] = useState(
    defaultShowAbstracts
  );
  const handleToggleAbstracts = () => {
    toggleAbstracts();
    setIsShowingAbstracts((isShowing) => !isShowing);
  };

  return (
    <StudyListSidebar
      {...sidebarProps}
      closeButtonLabel="Close highlights"
      disclosureId={disclosureId}
      title="Highlights"
      hasHeaderDivider
    >
      <HighlightsPanel
        layout="sidebar"
        studyListDisplayOptions={{
          showAbstracts: isShowingAbstracts,
          toggleAbstracts: handleToggleAbstracts,
          toggleHighlights,
          enableHighlights,
        }}
        pollForUpdates
      />
    </StudyListSidebar>
  );
};
